import { render, staticRenderFns } from "./settingPrivilegeModal.vue?vue&type=template&id=731f2bb0&"
import script from "./settingPrivilegeModal.vue?vue&type=script&lang=js&"
export * from "./settingPrivilegeModal.vue?vue&type=script&lang=js&"
import style0 from "./settingPrivilegeModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports